var unit_features ={
  unit_features: {
    bathtub: {
    id: "1",
    txt_id: "bathtub",
    name: "Bathtub",
    description: null,
    default_icon_location: null
    },
    bbq: {
    id: "2",
    txt_id: "bbq",
    name: "BBQ Ready",
    description: null,
    default_icon_location: null
    },
    coin_laundry: {
    id: "3",
    txt_id: "coin_laundry",
    name: "Coin Laundry",
    description: null,
    default_icon_location: null
    },
    dishwasher: {
    id: "6",
    txt_id: "dishwasher",
    name: "Dishwasher",
    description: null,
    default_icon_location: null
    },
    fridge: {
    id: "8",
    txt_id: "fridge",
    name: "Fridge",
    description: null,
    default_icon_location: null
    },
    garbage_chute: {
    id: "9",
    txt_id: "garbage_chute",
    name: "Garbage Collection",
    description: null,
    default_icon_location: null
    },
    dryer: {
    id: "7",
    txt_id: "dryer",
    name: "In Suite Dryer",
    description: null,
    default_icon_location: null
    },
    washer: {
    id: "25",
    txt_id: "washer",
    name: "In Suite Washer",
    description: null,
    default_icon_location: null
    },
    jacuzzi: {
    id: "14",
    txt_id: "jacuzzi",
    name: "Jacuzzi",
    description: null,
    default_icon_location: null
    },
    tv_unit: {
    id: "23",
    txt_id: "tv_unit",
    name: "TV Unit",
    description: null,
    default_icon_location: null
    },
    disable_ready: {
    id: "5",
    txt_id: "disable_ready",
    name: "Wheelchair Accessible",
    description: null,
    default_icon_location: null
    },
    microwave: {
    id: "27",
    txt_id: "microwave",
    name: "Microwave",
    description: null,
    default_icon_location: null
    },
    carpets: {
    id: "28",
    txt_id: "carpets",
    name: "Carpets",
    description: null,
    default_icon_location: null
    },
    garburator: {
    id: "29",
    txt_id: "garburator",
    name: "Garburator",
    description: null,
    default_icon_location: null
    },
    windows_covering: {
    id: "30",
    txt_id: "windows_covering",
    name: "Windows Covering",
    description: null,
    default_icon_location: null
    },
    sewage_disposal: {
    id: "31",
    txt_id: "sewage_disposal",
    name: "Sewage disposal",
    description: null,
    default_icon_Location: null
    },
    snow_removal: {
    id: "32",
    txt_id: "snow_removal",
    name: "Snow Removal",
    description: null,
    default_icon_location: null
    },
    stove_top: {
    id: "37",
    txt_id: "stove_top",
    name: "Stove Top",
    description: null,
    default_icon_location: null
    },
    oven: {
    id: "38",
    txt_id: "oven",
    name: "Oven",
    description: null,
    default_icon_location: null
    },
    air_conditioning: {
    id: "39",
    txt_id: "air_conditioning",
    name: "Air Conditioning",
    description: null,
    default_icon_location: null
    },
  }
}

module.exports = unit_features
